// 工作台-问诊-主列表
const phoneColumns = [
  {
    title: '呼出人',
    dataIndex: 'callerType',
    key: 'callerType',
    align: 'left',
    width: 200,
    slots: {
      customRender: 'callerType'
    }
  },
  {
    title: '接听人',
    width: 200,
    dataIndex: 'calleeName',
    key: 'calleeName',
    slots: {
      customRender: 'calleeName'
    }
  },
  {
    title: '开始时间',
    dataIndex: 'tcccStartTime',
    key: 'tcccStartTime',
    width: 200
  },
  {
    title: '结束时间',
    dataIndex: 'tcccEndTime',
    key: 'tcccEndTime',
    width: 200
  },
  {
    title: '咨询时长',
    dataIndex: 'tcccDuration',
    key: 'tcccDuration',
    width: 200,
    slots: {
      customRender: 'tcccDuration'
    }
  },
  {
    title: '通话状态',
    dataIndex: 'tcccEndStatusStr',
    key: 'tcccEndStatusStr',
    width: 200
  }
]
// 会话状态
/**
 * 会话结束状态：
 * ok正常结束、unconnected未接通、error系统错误、
 * unknown未知状态、notAnswer未接听、userReject拒接挂断、
 * powerOff关机、numberNotExist空号、busy通话中、
 * outOfCredit欠费、operatorError运营商线路异常、callerCancel主叫取消、notInService不在服务区
 */
// export const tcccEndStatusMap = {
//   ok: '正常结束',
//   unconnected: '未接通',
//   error: '系统错误',
//   unknown: '未知状态',
//   notAnswer: '未接听',
//   userReject: '拒接挂断',
//   powerOff: '关机',
//   numberNotExist: '空号',
//   busy: '通话中',
//   outOfCredit: '欠费',
//   operatorError: '运营商线路异常',
//   callerCancel: '主叫取消',
//   notInService: '不在服务区',
//   ivrEnd: '语音播放结束挂断',
//   callerCancelWhileRing: '响铃取消'
// }
const videoColumns = [
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    width: 200
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    width: 200
  },
  {
    title: '咨询时长',
    dataIndex: 'tcccDuration',
    key: 'tcccDuration',
    width: 200,
    slots: {
      customRender: 'tcccDuration'
    }
  }
]
export { phoneColumns, videoColumns }
